import React from "react";
import { Link } from "react-router-dom";
import { Github, Twitter, Linkedin, Facebook, Instagram } from "lucide-react";
import { useSite } from "../contexts/SiteContext";
import { mediaUrl } from "../lib/api";

export const Footer = () => {
  const { settings, tabs } = useSite();

  return (
    <footer
      className="border-t border-white/10 bg-[#020205] mt-24"
      data-testid="site-footer"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <img
            src={mediaUrl(settings.logo_url)}
            alt={settings.brand_name}
            className="h-14 w-auto object-contain drop-shadow-[0_0_22px_rgba(255,214,10,0.45)] logo-shimmer"
            data-testid="footer-logo"
          />
          <p className="text-zinc-400 mt-4 max-w-md text-sm leading-relaxed">
            {settings.tagline}
          </p>
          <div className="flex items-center gap-3 mt-6">
            {settings.social?.twitter && (
              <a
                href={settings.social.twitter}
                data-testid="footer-twitter"
                target="_blank" rel="noreferrer"
                className="w-9 h-9 rounded-full border border-white/10 flex items-center justify-center hover:border-[#00F0FF] hover:text-[#00F0FF] text-zinc-400 transition"
              >
                <Twitter className="w-4 h-4" />
              </a>
            )}
            {settings.social?.github && (
              <a
                href={settings.social.github}
                data-testid="footer-github"
                target="_blank" rel="noreferrer"
                className="w-9 h-9 rounded-full border border-white/10 flex items-center justify-center hover:border-[#00F0FF] hover:text-[#00F0FF] text-zinc-400 transition"
              >
                <Github className="w-4 h-4" />
              </a>
            )}
            {settings.social?.linkedin && (
              <a
                href={settings.social.linkedin}
                data-testid="footer-linkedin"
                target="_blank" rel="noreferrer"
                className="w-9 h-9 rounded-full border border-white/10 flex items-center justify-center hover:border-[#00F0FF] hover:text-[#00F0FF] text-zinc-400 transition"
              >
                <Linkedin className="w-4 h-4" />
              </a>
            )}
            {settings.social?.facebook && (
              <a
                href={settings.social.facebook}
                data-testid="footer-facebook"
                target="_blank" rel="noreferrer"
                className="w-9 h-9 rounded-full border border-white/10 flex items-center justify-center hover:border-[#00F0FF] hover:text-[#00F0FF] text-zinc-400 transition"
              >
                <Facebook className="w-4 h-4" />
              </a>
            )}
            {settings.social?.instagram && (
              <a
                href={settings.social.instagram}
                data-testid="footer-instagram"
                target="_blank" rel="noreferrer"
                className="w-9 h-9 rounded-full border border-white/10 flex items-center justify-center hover:border-[#00F0FF] hover:text-[#00F0FF] text-zinc-400 transition"
              >
                <Instagram className="w-4 h-4" />
              </a>
            )}
          </div>
        </div>

        <div>
          <p className="text-xs uppercase tracking-[0.2em] text-zinc-500 font-bold">
            Explore
          </p>
          <ul className="mt-4 space-y-2 text-sm">
            {tabs.map((t) => (
              <li key={t.id || t.path}>
                <Link to={t.path} className="text-zinc-300 hover:text-[#00F0FF]">
                  {t.label}
                </Link>
              </li>
            ))}
            <li>
              <Link
                to="/admin"
                data-testid="footer-admin-link"
                className="text-zinc-400 hover:text-[#00FF66] transition-colors"
              >
                Admin Panel
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <p className="text-xs uppercase tracking-[0.2em] text-zinc-500 font-bold">
            Contact
          </p>
          <ul className="mt-4 space-y-2 text-sm text-zinc-400">
            {settings.contact?.email && <li>{settings.contact.email}</li>}
            {settings.contact?.phone && <li>{settings.contact.phone}</li>}
            {settings.contact?.address && <li>{settings.contact.address}</li>}
          </ul>
        </div>
      </div>
      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-6 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-xs text-zinc-500">
            {settings.footer_text} {new Date().getFullYear()}
          </p>
          <p className="text-xs text-zinc-500 font-mono">
            built for teams who refuse to repeat themselves.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
